import React, { Component } from "react";
import usMap from './states-albers-10m'
import css from './RatioMap.css'
import stateMap from '../RegionSelect/stateMap'
class ColorSchemeModel {
  constructor() {
    this.scheme = [
      {
        range: {
          from: -1,
          to: 100
        },
        color: "#dce4ea",
        hover: "rgb(227,233,238)"
      },{
        range: {
          from: 101,
          to: 500
        },
        color: "rgba(179, 200, 218, 0.99)",
        hover: "rgb(194,211,225)"
      },{
        range: {
          from: 501 ,
          to: 1000
        },
        color: "#cdd9a9",
        hover: "rgb(215,224,186)"
      },{
        range: {
          from: 1001,
          to: 2000,
        },
        color: "#e8c17c",
        hover: "rgb(236,205,150)"
      },{
        range: {
          from: 2000,
          to: +Infinity
        },
        color: "#e29893",
        hover: "rgb(231,172,168)"
      }
    ]
  }
  
  picker(countString) {
    const count = Number(countString);
    const scheme = this.scheme.find(sh=> (count > sh.range.from && count <= sh.range.to));
    if(!scheme) return this.scheme[0].color;
    return scheme.color;
  }

  pickerHover(countString) {
    const count = Number(countString);
    const scheme = this.scheme.find(sh=> (count > sh.range.from && count <= sh.range.to));
    if(!scheme) return this.scheme[0].color;
    return scheme.hover;
  }

  legend() {
    return this.scheme.map(scheme => {
      let description = ''
      if(scheme.range.from < 0) description = `Below ${scheme.range.to}`
      else if(!isFinite(scheme.range.to)) description = `Above ${scheme.range.from}`
      else description = `${scheme.range.from} ~ ${scheme.range.to}`

      return {
        description,
        color: scheme.color
      }
    })
  }
}

const colorScheme = new ColorSchemeModel();

const locationGroup = stateMap;

const locationGroupHas = (region, field) => {
  if(region === 'usa') return true;
  return locationGroup[region].includes(field)
}

const viewBoxGroup = {
  usa: {k: 1, x: 91, y: 77},
  north:  {k: 3.4822022531844996, x: -2455.702849813781, y: -295.06898840305314},
  midWest:{k: 2.000000000000001, x: -732.3921606201212, y: -25.319584261086618},
  plains: {k: 1.1486983549970353, x: 55.88959872995247, y: 15.345407780635526},
  south:{k: 1.741101126592249, x: -655.9343221640731, y: -354.31680379053},
  west: {k: 1.3195079107728946, x: 332.8178502207618, y: 57.99735010641575},
  other:{k: 3.0314331330207986, x: 231.90019225063526, y: -1220.242530843021},
}

const color = (count) => colorScheme.picker(count)
const hover = (count) => colorScheme.pickerHover(count)
const us = JSON.parse(usMap);

const pickLocation = (data, addrs) => addrs.length ? data.filter(geometrie => addrs.includes(geometrie.properties.addr)) : data;

const maskNumber = (number) => `**${number % 10}`

const safeGet = (object, field) => object && object[field] || 0

const popupElement = (locationName, totalCount = "--", inCount = "--", outCount = "--", unLock) => `
<div class="_-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupWarp" data-id="${locationName}">
  <div class="_-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupColorItem">
    <div class="_-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupColorEmpty"></div>
    <div class="_-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupColor" style="background-color: ${color(totalCount)}" ></div>
  </div>
  <div class="_-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupItem _-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupItemState">
    <div class="_-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupTitle">State</div>
    <div class="_-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupCourt">${locationName}</div>
  </div>
  <div class="_-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupColorBr"></div>
  <div class="_-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupItem">
    <div class="_-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupTitle">Inbound</div>
    <div class="_-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupCourt">${unLock ? totalCount : maskNumber(totalCount)}</div>
  </div>
  <div class="_-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupColorBr"></div>
  <div class="_-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupItem">
    <div class="_-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupTitle">Intrastate</div>
    <div class="_-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupCourt">${unLock ? inCount : maskNumber(inCount)}</div>
  </div>
  <div class="_-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupColorBr"></div>
  <div class="_-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupItem">
    <div class="_-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupTitle">Outbound</div>
    <div class="_-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupCourt">${unLock ? outCount : maskNumber(outCount)}</div>
  </div>
  <div class="_-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupMaskWarp" ${unLock ? 'style="display: none"' : ""}>
    <div class="_-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupMaskTitle">
      Upgrade your account
    </div>
    <div class="_-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupMaskUnlockBtn">
      <span class="_-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupMaskUnlockIcon"></span>
      <span>UNLOCK</span> 
    </div>
  </div>
  <div class="_-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupTriangleBorder"></div>
  <div class="_-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupTriangle"></div>
</div>
`

const stateNameAlign = {
  "MI" : {
    x: 5,
    y: 20
  },
  "KY" : {
    x: 0,
    y: 10
  },
  "LA" : {
    x: -14,
    y: 0
  },
  "FL": {
    x:15,
    y:15 
  }
}

const drawMap = (mapContainer, mapData, region, {mouseOver, mouseOut, click, refreshLocation}, popupDom) => {
  //remove old svg 
  const oldMap = mapContainer.select("svg");
  oldMap&&oldMap.remove();
  allMap 
  const filterMap =  JSON.parse(usMap);
  const allMap =  JSON.parse(usMap);
  filterMap.objects.states.geometries = pickLocation(us.objects.states.geometries, locationGroup[region]);
  const map = mapContainer.append("svg")
    .attr("width", 1080)
    .attr("height", 727)
    .attr("viewBox", "0 0 1080 727")

  

  map
    .append("g")
    .attr("data-mapblock", "1")
    .selectAll("path")
    .data(topojson.feature(allMap, allMap.objects.states).features)
    .join("path")
    .attr("fill", (d) => {
      if(locationGroupHas(region , d.properties.addr)) {
        return color(safeGet(mapData[d.properties.addr], 'count'))
      }
      return "#EBEBEB"
    })
    .attr('style', 'cursor: pointer;user-select: none;')
    .attr("data-mapState", (d) => d.properties.addr)
    .attr("stroke", "white")
    .attr("d", d3.geoPath())
    .on("mouseover",  (d, i) => {
      if(locationGroupHas(region , i.properties.addr)) {
        mouseOver && mouseOver(d, i, region)
      }
    })
    .on("mouseout",  (d, i) => {
      const {clientX,clientY} = d;
      const { top, bottom, left, right } = popupDom.getBoundingClientRect();
      if(clientY > top && clientY < bottom + 60 && clientX > left && clientX < right) return
      mouseOut && mouseOut(d, i)
    })
    .on("click",  (d, i) => {
      if(locationGroupHas(region , i.properties.addr)) {
        click && click(d, i)
      }
    })
    // add state name 
    map
      .append("g")
      .attr("data-maptext", "1")
      .selectAll("text")
      .data(topojson.feature(allMap, allMap.objects.states).features)
      .enter()
      .append("svg:text")
      .text(function(d){
        if(region !== "north" && ["VT","NH","MA", "CT", "RI", "NJ", "DE", "MD", "DC"].includes(d.properties.addr)){
          return "."
        }
        return d.properties.addr;
      })
      .attr("x", function(d){
        return d3.geoPath().centroid(d)[0] + (stateNameAlign[d.properties.addr] ? stateNameAlign[d.properties.addr].x : 0)
      })
      .attr("y", function(d){
        return  d3.geoPath().centroid(d)[1] + (stateNameAlign[d.properties.addr] ? stateNameAlign[d.properties.addr].y : 0);
      })
      .attr("data-popid", function(d){
        return d.properties.addr;
      })
      .attr("text-anchor","middle")
      .attr('fill', (d) => {
        if(locationGroupHas(region , d.properties.addr)) {
          return "#141a42"
        }
        return "#B2B6C0"
      })
      .attr('font-weight', '600')
      .attr('style', 'cursor: pointer;user-select: none;pointer-events:none;')
      .attr('font-size', "1.25em")
    const zoom = d3.zoom().extent([[0, 0], [1080, 727]]).scaleExtent([1, 8]).on("zoom", zoomed);
    mapContainer.select("svg").call(
      zoom
    ).call(
      zoom.transform,
      d3.zoomIdentity.translate(viewBoxGroup[region].x, viewBoxGroup[region].y).scale(viewBoxGroup[region].k)
    )
    function drawRemainText (scale) {
      if(region === "usa") {
        if(scale > 4) {
          ["VT","NH","MA", "CT", "RI", "NJ", "DE", "MD", "DC"].map(state=> {
            const stateItem = d3.select(`[data-maptext="1"]`).select(`[data-popid="${state}"]`);
            if(stateItem) stateItem.text(state)
          })
        }else {
          ["VT","NH","MA", "CT", "RI", "NJ", "DE", "MD", "DC"].map(state=> {
            const stateItem = d3.select(`[data-maptext="1"]`).select(`[data-popid="${state}"]`);
            if(stateItem) stateItem.text('.')
          })
        }
      }
    }

    function zoomed({transform}) {
      d3.select(`[data-mapblock="1"]`).attr("transform", transform);
      d3.select(`[data-maptext="1"]`).attr("transform", transform);
      d3.select(`[data-maptext="1"]`).selectAll("text").join("text").attr("font-size", 1.25/transform.k + "em")
      drawRemainText(transform.k)
      refreshLocation();
    }

    /* function autoZoomed({k, x, y}) {
      d3.select(`[data-mapblock="1"]`).attr("transform", `translate(${x},${y}) scale(${k})`);
      d3.select(`[data-maptext="1"]`).attr("transform", `translate(${x},${y}) scale(${k})`);
      d3.select(`[data-maptext="1"]`).selectAll("text").join("text").attr("font-size", 1.25/k + "em")
    }
    autoZoomed(viewBoxGroup[region]) */
}

class RatioMap extends Component {
  constructor(props) {
    super(props);
    this.div = false;
    this.popup = (e) => {
      e.stopPropagation();
      props.popUp("capacity_ratio_map"); 
      if(this.div) this.div.transition().duration(50).style("opacity", 0); 
    }
    this.activeLocation = ""
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.timeStamp !== this.props.timeStamp) return true;
    return false;
  }
  render() {
    return(
        <div ref="map" className={css.CapacityRatioMapContainer}>
          <div className={css.CapacityRatioMapLegendPosition}>
            <div className={css.CapacityRatioMapLegend}>
              {
                colorScheme.legend().reverse().map(scheme=> (
                  <div className={css.CapacityRatioMapLegendItem}>
                    <div 
                      className={css.CapacityRatioMapLegendColorBlock} 
                      style={{backgroundColor: scheme.color}}>
                    </div>
                    {scheme.description}
                    </div>
                ))
              }
            </div>
          </div>
          <div ref="popup" className={css.CapacityRatioMapPopup}></div>
        </div>
    )
  }
  jumpToPage = (id) => {
    const { jumpTo } = this.props;
    jumpTo(id);
  }
  
  mouseOver = (d, i, region) => {
    this.div.node().classList.remove(css.hideAll);
    const { mapData, isMember} = this.props;
    this.activeLocation = i.properties.addr
    const textHref = document.querySelector(`[data-popid="${i.properties.addr}"]`);
    d3.select(`[data-mapblock="1"]`).selectAll("path").join("path").attr("fill", (d)=> {
      if(locationGroupHas(region , d.properties.addr)) {
        if(d.properties.addr === this.activeLocation) return hover(safeGet(mapData[d.properties.addr], 'count'))
        return color(safeGet(mapData[d.properties.addr], 'count'))
      }
      return "#EBEBEB"
    });
    const mapContainer = this.refs.map
    const { top, left } = textHref.getBoundingClientRect();
    const  {top: topParent, left: leftParent}= mapContainer.getBoundingClientRect();
    this.div.transition().duration(50).style("opacity", 1).style("left",left-leftParent-150 + "px").style("top", top-topParent-65 + "px")
    this.div.html(popupElement(i.properties.addr, safeGet(mapData[i.properties.addr], 'count') , safeGet(mapData[i.properties.addr], 'in'), safeGet(mapData[i.properties.addr], 'out'), isMember));
    document.querySelector("._-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupMaskUnlockBtn").addEventListener("click",this.popup);
  }
  refreshLocation = () => {
    if(!this.activeLocation) return;
    const textHref = document.querySelector(`[data-popid="${this.activeLocation}"]`);
    const mapContainer = this.refs.map
    const { top, left } = textHref.getBoundingClientRect();
    const  {top: topParent, left: leftParent}= mapContainer.getBoundingClientRect();
    this.div.style("left",left-leftParent-150 + "px").style("top", top-topParent-65 + "px")
  }

  mouseOut = (d, i) => {
    this.div.transition().duration(50).style("opacity", 0);
    this.div.node().classList.add(css.hideAll);
    this.activeLocation = ""
    document.querySelector("._-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupMaskUnlockBtn").removeEventListener("click",this.popup);
  }
  mouseClick = (d, i) => {
    this.jumpToPage(i.properties.addr);
  }
  componentDidMount () {
    const { mapData, popUp, region} = this.props;
    this.mapContainer = d3.select(this.refs.map);
    this.div = d3.select(this.refs.popup);
    this.refs.popup.addEventListener("click", (e)=> {
      this.jumpToPage(e.target.dataset.id)
    })
    this.div.on("mouseout",(d, i) => {
      if(
        d.toElement.classList.contains("_-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupMaskUnlockBtn") 
        || d.toElement.classList.contains("_-pages-CapacityRatio-compontents-RatioMap-CapacityRatioPopupWarp") 
      ) return;
      this.mouseOut(d, i)
    })
    drawMap(this.mapContainer, mapData , region, {mouseOver: this.mouseOver, mouseOut: this.mouseOut, click: this.mouseClick, refreshLocation: this.refreshLocation}, this.refs.popup);
  }
  componentWillUpdate() {
    const { mapData, region} = this.props;
    drawMap(this.mapContainer, mapData , region, {mouseOver: this.mouseOver, mouseOut: this.mouseOut, click: this.mouseClick, refreshLocation: this.refreshLocation}, this.refs.popup)
  }
}

export default RatioMap;



// WEBPACK FOOTER //
// ./src/pages/CapacityRatio/compontents/RatioMap/index.js